import { ButtonLink } from "../../shared/ui/Button/Button.tsx";
import { InstallApp } from "../../shared/install/InstallApp.tsx";
import { Logo } from "../../shared/ui/Logo.tsx";
import sunset from "./sunset.webp";
import styles from "./StartPage.module.css";

export function StartPage() {
  return (
    <main className={styles.page}>
      <Logo />
      <section className={styles.intro}>
        <img className={styles.art} src={sunset} width="800" height="800" alt="" />
        <h1 className={styles.title}>Твой стиль, твоя Eva</h1>
        <p className={styles.subtitle}>Украшай свой стол и меняй настроение</p>
      </section>
      <nav className={styles.actions}>
        <ButtonLink to="/login">Войти</ButtonLink>
        <ButtonLink to="/register" variant="secondary">
          Зарегистрироваться
        </ButtonLink>
        <InstallApp />
      </nav>
    </main>
  );
}
